export default {
    developing: {
        path: '/website/developing',
        name: 'developing',
        component: () => import('./index.vue')
    }
};
